import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "María G.",
    role: "Diseñadora Freelance",
    initials: "MG",
    text: "Antes perdía días enteros en el SAT. Ahora solo apruebo mi declaración desde el celular. ¡El mejor $350 que gasto al mes!",
    rating: 5,
  },
  {
    name: "Roberto H.",
    role: "Vendedor Independiente",
    initials: "RH",
    text: "Antes de declarar revisan mis ingresos y gastos para que todo quede bien. Con mi contador siempre vemos que este todo completo.",
    rating: 5,
  },
  {
    name: "Ana M.",
    role: "Consultora de Marketing",
    initials: "AM",
    text: "Probé Konta y Heru antes. SinConta tiene el mejor precio y el mismo servicio. Solo que con asesoría para pagar menos.",
    rating: 5,
  },
  {
    name: "Carlos M.",
    role: "Repartidor Uber",
    initials: "CM",
    text: "Siempre revisan las retenciones y buscan la forma para que no pague impuestos con mis gastos.",
    rating: 5,
  },
];

export function TestimonialsSection() {
  return (
    <section className="section-padding">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4">
            Lo que dicen nuestros <span className="gradient-text">clientes</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Más de 150 profesionistas ya confían en SinConta para sus impuestos
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="glass-card-hover p-8 relative"
            >
              <Quote className="absolute top-6 right-6 w-10 h-10 text-secondary/20" />
              
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, j) => (
                  <Star key={j} className="w-5 h-5 fill-accent text-accent" />
                ))}
              </div>

              <p className="text-foreground mb-6 relative z-10">"{testimonial.text}"</p>

              <div>
                <p className="font-semibold">{testimonial.name}</p>
                <p className="text-sm text-muted-foreground">{testimonial.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
